import {
    SUBMIT_UPDATE_REQUEST,
    SUBMIT_UPDATE_SUCCESS,
    SUBMIT_UPDATE_FAILURE,
  } from "../actions/actionTypes";
  import apiClient from "../../utils/apiClient";
  import { useNavigate } from "react-router-dom";
 
  const flattenMessage = (value) => {
    if (Array.isArray(value)) {
      return value.map(flattenMessage).filter(Boolean).join("\t");
    }

    if (value && typeof value === "object") {
      return Object.values(value).map(flattenMessage).filter(Boolean).join("\t");
    }

    if (value === null || value === undefined) {
      return "";
    }

    return String(value);
  };

  export const submitUpdateThunk = (updateData , uniqueId, verificationMethod, signature, regId) => {
    return async (dispatch) => {
      dispatch({ type: SUBMIT_UPDATE_REQUEST });
      try {
        const response = await apiClient.post(
          "/submitupdaterequest",
          { updateData, uniqueId, verificationMethod, signature, regId }
        );

        const data = response.data;
        if (data.response === "OK") {
            dispatch({ type: SUBMIT_UPDATE_SUCCESS, payload: data });
        }
        else {
          throw new Error("Failed to submit update request");
        }
      } catch (error) {
        const message = error?.response?.data?.message?.message || error.message || "update submit failed. Please try again later.";
         dispatch({
            type: SUBMIT_UPDATE_FAILURE,
            payload: message
          });


      }
    };
  };